import styled from 'styled-components'
import { space } from 'styled-system'

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${space};
`

export default Nav
